<template>
    <div id="fitb">
        <h4>Complete this statement:</h4>
        <div class="question" v-html="question" @keydown="onKeyDown"></div>
        <button class='ui button blue' v-on:click="submitClick" v-if="!answered">Submit</button>
        <FeedbackBox v-if="answered" v-bind:message="feedbackMessage" v-bind:correct="correct" v-bind:incorrect="incorrect" />
    </div>
</template>

<script>

import FeedbackBox from '../FeedbackBox.vue'
export default {
  name: 'FillInTheBlank',
  props: [
      'boosterData', 'leaderboards', 'api', 'programId', 'learnerId', 'boosterId'
  ],
  components: {
      FeedbackBox
  },
  mounted() {
      let q = this.boosterData.questionText;
      let input = '<textarea id="word-input" class="fitb-area"></textarea>';
      q = q.replace(/_+/, input);
      this.question = q;
  },
  methods: {
      submitClick: function () {
            this.checkAnswer()
      },
      onKeyDown: function(key) {
        if (key.keyCode == 13) {
            this.checkAnswer();
            key.preventDefault()
            key.stopPropagation();
            return false;
        } 
      },
      checkAnswer: function() {
        if (!this.answered) {
            this.answered = true;

            let area = this.$el.querySelector('textarea');
            let answer = area.value.toLowerCase()
            answer = answer.trim();
            answer = answer.split(" ").join("");

            let foundAnswer = false
            let pregex = /[.,/#!$%^&*;:{}=\-_`~()]/g;
            answer = answer.replace(pregex, "")
            for(var a = 0; a < this.boosterData.synonyms.length; a++) {
                let syn = this.boosterData.synonyms[a].toLowerCase();
                syn = syn.trim();
                syn = syn.split(" ").join("");
                syn = syn.replace(pregex, "");
                
                if (syn == answer) {
                    foundAnswer = true;
                }
            }

            if (foundAnswer) {
                this.correct = true
                this.feedbackMessage = this.boosterData.correctFeedback
                
            }
            else {
                this.incorrect = true
                this.feedbackMessage = this.boosterData.incorrectFeedback
            }

            if (this.correct && !this.incorrect) {
                if (this.leaderboards) {
                    this.pointsEarned = 5;
                    this.$bubble('earnedPoints', 5)
                }
            }

            if (this.api) {
                this.api.post('/api/event', {
                    code: 302,
                    lid: this.learnerId,
                    pid: this.programId,
                    bid: this.boosterId,
                    submission: answer,
                    correct: this.correct
                })
            }
        }
      }
  },
  data() {
      return {
          question: '',
          answered: false,
          correct: false,
          incorrect: false,
          feedbackMessage: '',
          pointsEarned: 0
      }
  }
}
</script>
<style scoped>
.correct-feedback {
    color: #019800;
    padding: 15px 0 15px 0;
}
.incorrect-feedback {
    color: #B21600;
    padding: 15px 0 15px 0;
}
.question {
    padding: 30px 0 30px 0;
}
</style>
<style>
.fitb-area {
    max-width: 150px;
    height: 22px;
    overflow: hidden;
    resize: none;
    vertical-align: top;
}
</style>